import {
  HeaderTabs,
  type TabWithIndicatorProps,
} from "@/components/Navigation/HeaderTabs";
import { defaultNS, useTranslation } from "@/lib/i18n";
import type { AppContractRes } from "../_$id/-query/type";

export default function AppIntegrationHeaderTabs({
  id,
  isSubordinate,
  parentApp,
}: {
  id: string;
  isSubordinate: boolean;
  parentApp: AppContractRes["parentApp"];
}) {
  const { t } = useTranslation(defaultNS, { keyPrefix: "common.list" });

  const allLinks: TabWithIndicatorProps[] = [
    {
      to: "/app-integrations/$id",
      activeOptions: { exact: true },
      params: { id },
      children: t("overview"),
    },
    {
      to: "/app-integrations/$id/users",
      params: { id },
      children: t("users"),
    },
    {
      to: "/app-integrations/$id/groups",
      params: { id },
      children: t("groups"),
    },
    {
      to: "/app-integrations/$id/detail",
      params: { id },
      children: t("software.detail"),
    },
    {
      to: "/app-integrations/$id/architecture",
      params: { id },
      children: t("software.architecture"),
    },
    {
      to: "/app-integrations/$id/rule-and-policy",
      params: { id },
      children: t("ruleAndPolicy"),
    },
    // isSubordinateの場合、設定タブは親アプリの設定ページへのリンクになる
    isSubordinate && parentApp?.appIntegrationId
      ? {
          to: "/app-integrations/$id/settings",
          params: { id: parentApp.appIntegrationId },
          children: t("settings"),
          target: "_blank" as const,
        }
      : {
          to: "/app-integrations/$id/settings",
          params: { id },
          children: t("settings"),
        },
  ];

  // isSubordinateの場合、概要タブとルール&ポリシータブを除外
  const links = isSubordinate
    ? allLinks.filter(
        (link) =>
          link.to !== "/app-integrations/$id" &&
          link.to !== "/app-integrations/$id/rule-and-policy",
      )
    : allLinks;

  return <HeaderTabs tabs={links} />;
}
